import { Input, Divider, Select, Form, Col, Button, Table, Tag } from "antd";
import Typography from "../../Typography";
import { COLORS } from "../../../constants/Colors";
import MyInput from "../../Input";
import { useState, useRef, useEffect, useCallback, useContext } from "react";
import { Option } from "antd/es/mentions";
import useIsDesktop from "../../../utils/hooks/useIsDesktop";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import CustomTable from "../../TableComponent";
import { QueueContext } from "./queue-context";

const { TextArea } = Input;

const QueueView = (props) => {
  const { form, columns, productList, recordQueue, deliveryType } = props;
  const Lang = localStorage.getItem("lang");
  const isDesktop = useIsDesktop();
  const intl = useIntl();
  const [typeName, setTypeName] = useState("");

  console.log("formformform", recordQueue);

  useEffect(() => {
    const getType = () => {
      const FilterType = _.get(
        _.filter(deliveryType, (i) => {
          return i.orderTypeCode === _.get(recordQueue, "orderType");
        }),
        "[0]"
      );
      setTypeName(_.get(FilterType,'typeLang'))
    };
    if (_.size(recordQueue) > 0) {
      getType();
    }
  }, [recordQueue]);

  const layout = {
    wrapperCol: { span: 24 }, // กำหนดความกว้างของพื้นที่ที่บรรจุ Component
  };

  return (
    <div
      className="d-flex flex-column py-0 m-2"
      style={{ height: isDesktop ? undefined: '60vh' }}
      // style={{ height: "calc(100vh - 305px)", overflowY: "auto" }}
    >
      <Form {...layout} form={form}>
        <div
          className={`d-flex flex-row pb-0`}
        >
          <Col className="px-0" span={isDesktop ? 12 : 12}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography isBold color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormLotPark"
                    defaultMessage="ช่องจอด เลขตู้"
                  />
                </Typography>
              </div>
              <Form.Item>
                {" "}
                {_.get(recordQueue, "assetClassIdCarlot") +
                  " " +
                  _.get(recordQueue, "assetNameCarlot")}{" "}
              </Form.Item>
            </div>
          </Col>
          <div className={ isDesktop ? 'mr-4' :"mr-0"} />
          <Col className="px-0" span={isDesktop ? 11 : 12}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1"></div>
              <Form.Item name="customer">
                <Tag
                  className="tag-queue-right"
                  style={{ height: "24px" }}
                  color={_.get(recordQueue, "statusMapView.color")}
                >
                  <Typography
                    className="p-1"
                    isBold
                    color={COLORS.White}
                    size={"14px"}
                    textAlign={"center"}
                  >
                    { Lang === 'TH' ? _.get(recordQueue, "statusMapView.txt.TH")  :_.get(recordQueue, "statusMapView.txt.EN")}
                  </Typography>
                </Tag>
              </Form.Item>
            </div>
          </Col>
        </div>

        <div className={`d-flex flex-row`}>
          <Col className="px-0" span={isDesktop ? 12 : 12}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography isBold color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormCustomer"
                    defaultMessage="ผู้ค้า / ลูกค้า"
                  />
                </Typography>
              </div>
              <Form.Item name="customer">
                {_.get(recordQueue, "serialNoMarket") +
                  " " +
                  _.get(recordQueue, "assetNameMarket") || ""}{" "}
              </Form.Item>
            </div>
          </Col>
          <div className={ isDesktop ? 'mr-4' :"mr-0"} />
          <Col className="px-0" span={isDesktop ? 11 : 12}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography isBold color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormRef"
                    defaultMessage="อ้างอิง"
                  />
                </Typography>
              </div>

              <Form.Item> {_.get(recordQueue, "referenceNo") || "-"}</Form.Item>
            </div>
          </Col>
        </div>

        <div className={`d-flex flex-row`}>
          <Col className="px-0" span={isDesktop ? 12 : 12}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography isBold color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormTranType"
                    defaultMessage="วิธีจัดส่ง"
                  />
                </Typography>
              </div>
              <Form.Item name="type">{typeName}</Form.Item>
            </div>
          </Col>
          <div className={ isDesktop ? 'mr-4' :"mr-0"} />
          {/* <Col className="px-0" span={isDesktop ? 11 : 12}>
            <div className="w-100">
              <div className="d-flex align-items-center pb-1">
                <Typography isBold color={COLORS.Purple} className="pb-1">
                  <FormattedMessage
                    id="createQueueFormRegis"
                    defaultMessage="ทะเบียนรถ"
                  />
                </Typography>
              </div>

              <Form.Item>
                { _.get(recordQueue, "orderType") === 'SELF-DO' ? _.get(recordQueue, "carLicensePlat") : '-'}
              </Form.Item>
            </div>
          </Col> */}
        </div>
      </Form>
      <div className="pb-0 px-0 d-flex align-items-center justify-content-between">
        <Typography className="pb-3 pt-0 px-0" isBold color={COLORS.Purple}>
          <FormattedMessage
            id="createQueueFormProduct"
            defaultMessage="สินค้า"
          />
        </Typography>
      </div>
      <Divider className="mx-0 mt-0 mb-0" />
      <CustomTable
        column={columns}
        // data={_.size(productList) > 0 ? productList : []}
        data={productList}
        pagination={false}
        scroll={{ x: _.sumBy(columns, "width") }}
      />
    </div>
  );
};

export default QueueView;
